import { useServiceCache } from '@/providers/ServiceCacheContext'
import { IAppointment, IServiceAppointments } from '@/service/types'
import { Box, CircularProgress, Typography } from '@mui/material'

interface FreeAppointmentsProps {
  services: IServiceAppointments[]
}

const FreeAppointments = (props: FreeAppointmentsProps) => {
  const { loading: servicesLoading, getServiceForCode } = useServiceCache()
  const { services } = props

  const numberColor = (number: number) => {
    if (number < 20) {
      return ''
    }
    if (number < 10) {
      return '#ffa726'
    }
    if (number < 5) {
      return '#d32f2f'
    }
  }

  if (servicesLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'end',
          height: '100%',
        }}
      >
        <CircularProgress sx={{ mb: 2 }} />
      </div>
    )
  }

  return (
    <Box mb={1.5}>
      {services.map(({ service, hours }) => {
        const availableApponitments: IAppointment[] = []
        hours.forEach((element) =>
          element.appointments.forEach((element) => {
            if (element.status === 'AVAILABLE') {
              availableApponitments.push(element)
            }
          }),
        )
        const hungarianName = getServiceForCode(service)?.name || service

        return (
          <Box display="flex" key={hungarianName}>
            <Typography variant="body2" mr={0.5}>
              {hungarianName}:
            </Typography>
            <Typography
              variant="body2"
              fontWeight={600}
              color={numberColor(availableApponitments.length)}
            >
              {availableApponitments.length}
            </Typography>
          </Box>
        )
      })}
    </Box>
  )
}

export default FreeAppointments
